export default __webpack_public_path__ + "static/media/option.ba37d391.svg";